let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("juVlo"), load("9gJO7"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("4g8hn")]).then(() => parcelRequire('l2PDp'));